import { Box, styled } from '@mui/material';
import { sanguine, ultraMarine } from '../../../../../utils/colors';

export const ButtonRow = styled(Box)({
  display: 'flex',
  gap: 8,
});

const StyledBox = styled(Box)({
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 4,
  '& > .MuiSvgIcon-root': {
    fontSize: 58,
    color: sanguine[400],
  },
  '& .MuiTypography-root': {
    color: sanguine[400],
    fontSize: 14,
    lineHeight: '16px',
    textAlign: 'center',
    fontWeight: 600,
  },
  '& .MuiButton-root': {
    fontSize: 14,
    fontWeight: 600,
    color: ultraMarine[600],
    textTransform: 'none',
    display: 'flex',
    gap: 4,
    '&:hover': {
      textDecoration: 'underline',
    },
    '& svg': {
      fontSize: 16,
    },
  },
});

export default StyledBox;
